import produce from 'immer'
import { ReactElement } from 'react';
import { Reducer } from 'redux'

import {
  PAGE_RENDER_LEFT,
  SET_PAGE_LEFT,
  SET_PAGE_PARAMETERS,
  SET_PAGE_OVERLAY,
  SET_PAGE_VIEW,
  SET_IS_MOUSE_ABILITY_OPEN
} from 'redux/actions/types'

interface PageState {
  left: ReactElement|null;
  overlay:ReactElement|null;
  display:string;
  pageView:string|null;
  isMouseAbilityOpen:boolean;
  configParameters:any
}

const initialState:PageState = {
  left: null,
  overlay: null,
  display: 'block',
  pageView: null,
  isMouseAbilityOpen: false, // TODO: delete ?
  configParameters: null
}

const page:Reducer<PageState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGE_LEFT:
      return produce(state, draft => {
        draft.left = action.left
      })
    case PAGE_RENDER_LEFT:
      return produce(state, draft => {
        if (action.component) {
          draft.left = action.component
        } else {
          draft.left = null
          draft.pageView = 'main'
        }
      })
    case SET_PAGE_VIEW:
      return produce(state, draft => {
        draft.pageView = action.pageView
      })
    case SET_PAGE_OVERLAY:
      return produce(state, draft => {
        draft.overlay = action.overlay
      })
    case SET_IS_MOUSE_ABILITY_OPEN:
      return produce(state, draft => {
        draft.isMouseAbilityOpen = action.isMouseAbilityOpen
      })
    case SET_PAGE_PARAMETERS:
      return produce(state, draft => {
        draft.configParameters = action.pageParameters
      })
    default:
      return state
  }
}

export default page
